// Technology page translations; names, API identifiers and source claims stay unchanged.
export const technologyMessages = Object.fromEntries(
  [
    ['MODELO BASE', 'BASE MODEL', 'MODELO BASE'],
    [
      'Con razonamiento extendido',
      'With extended reasoning',
      'Com raciocínio estendido',
    ],
    ['CLIENTES MCP', 'MCP CLIENTS', 'CLIENTES MCP'],
    ['11 compatibles', '11 compatible clients', '11 clientes compatíveis'],
    ['TOOLS EXPUESTAS', 'AVAILABLE TOOLS', 'FERRAMENTAS DISPONÍVEIS'],
    ['34 tools + 4 recursos', '34 tools + 4 resources', '34 tools + 4 recursos'],
    [
      'Visibilidad, competidores, schema, acciones',
      'Visibility, competitors, schema, actions',
      'Visibilidade, concorrentes, schema, ações',
    ],
    ['TRAZABILIDAD', 'TRACEABILITY', 'RASTREABILIDADE'],
    ['PERMISOS', 'PERMISSIONS', 'PERMISSÕES'],
    ['03 / Agente + MCP', '03 / Agent + MCP', '03 / Agente + MCP'],
    [
      'La plataforma que trabaja',
      'The platform that works',
      'A plataforma que trabalha',
    ],
    ['mientras tú vendes.', 'while you sell.', 'enquanto você vende.'],
    [
      'Un agente que monitorea, alerta y actúa en lenguaje natural. Y un servidor MCP para que Claude, Cursor o tu propio agente consulten Bison como si fuera una herramienta nativa — una integración clave para la optimización conversacional.',
      'An agent that monitors, alerts and acts in natural language. An MCP server lets Claude, Cursor or your own agent query Bison as a native tool, supporting conversational optimization.',
      'Um agente que monitora, alerta e age em linguagem natural. Um servidor MCP permite que Claude, Cursor ou seu próprio agente consulte a Bison como uma ferramenta nativa, apoiando a otimização conversacional.',
    ],
    ['PLAN Growth', 'Growth PLAN', 'PLANO Growth'],
    [
      'Score AEO cruzó umbral configurado',
      'AEO Score crossed the configured threshold',
      'O Score AEO ultrapassou o limite configurado',
    ],
    [
      'Nuevo competidor citado > 3 veces en 7d',
      'New competitor cited > 3 times in 7 days',
      'Novo concorrente citado > 3 vezes em 7 dias',
    ],
    [
      'Acción del playbook marcada terminada por tu equipo',
      'Playbook action marked complete by your team',
      'Ação do playbook marcada como concluída pela sua equipe',
    ],
    [
      'Reporte semanal PDF disponible para descarga',
      'Weekly PDF report ready to download',
      'Relatório semanal em PDF disponível para download',
    ],
    [
      'Todo lo que ves en el dashboard',
      'Everything you see in the dashboard',
      'Tudo o que você vê no painel',
    ],
    ['es API.', 'is available through the API.', 'está disponível pela API.'],
    [
      'El producto es la API; el dashboard es un cliente. Si tu equipo de data prefiere consumirlo desde Looker, dbt o un notebook, te damos endpoint REST + webhooks para cada evento.',
      'The API is the product; the dashboard is a client. If your data team prefers Looker, dbt or a notebook, we provide REST endpoints and webhooks for each event.',
      'A API é o produto; o painel é um cliente. Se sua equipe de dados prefere Looker, dbt ou um notebook, oferecemos endpoints REST e webhooks para cada evento.',
    ],
    [
      'Request · GET cobertura',
      'Request · GET coverage',
      'Requisição · GET cobertura',
    ],
    [
      'Webhooks · eventos principales',
      'Webhooks · key events',
      'Webhooks · principais eventos',
    ],
    ['ESTRUCTURA SEMÁNTICA', 'SEMANTIC STRUCTURE', 'ESTRUTURA SEMÂNTICA'],
    [
      'Atributos que los algoritmos entienden',
      'Attributes algorithms understand',
      'Atributos que os algoritmos entendem',
    ],
    [
      'Los motores de compra en IA no leen páginas — parsean atributos. Estructuramos tu catálogo en el formato que los algoritmos de compra pueden comparar sin ambigüedad: precio, disponibilidad, especificaciones, variantes.',
      'AI shopping engines parse attributes. We structure your catalog so shopping algorithms can compare price, availability, specifications and variants without ambiguity.',
      'Os mecanismos de compra com IA analisam atributos. Estruturamos seu catálogo para que os algoritmos possam comparar preço, disponibilidade, especificações e variantes sem ambiguidade.',
    ],
    ['LENGUAJE DE MÁQUINA', 'MACHINE LANGUAGE', 'LINGUAGEM DE MÁQUINA'],
    [
      'Tu catálogo en el idioma de los motores',
      'Your catalog in the engines’ language',
      'Seu catálogo no idioma dos mecanismos',
    ],
    [
      'Cada motor lee el catálogo por su propia vía: Google con UCP y Merchant Center, ChatGPT con ACP y su feed de productos, Copilot, Perplexity y Muse a través de Shopify, Stripe o PayPal. Publicamos tu inventario para todos, no para uno: sin esa traducción, el motor puede mencionarte pero no venderte.',
      'Each engine reads catalogs differently: Google through UCP and Merchant Center, ChatGPT through ACP and its product feed, and Copilot, Perplexity and Muse through Shopify, Stripe or PayPal. We publish your inventory for all of them. Without that translation, an engine can mention your products but cannot sell them.',
      'Cada mecanismo lê catálogos de uma forma: Google via UCP e Merchant Center, ChatGPT via ACP e seu feed de produtos, e Copilot, Perplexity e Muse via Shopify, Stripe ou PayPal. Publicamos seu estoque para todos eles. Sem essa tradução, o mecanismo pode mencionar seus produtos, mas não vendê-los.',
    ],
    ['ZERO-CLICK COMMERCE', 'ZERO-CLICK COMMERCE', 'COMÉRCIO SEM CLIQUES'],
    [
      'Transacción sin salir del chat',
      'Transactions without leaving the chat',
      'Transações sem sair do chat',
    ],
    [
      'Google, Copilot, Perplexity y Muse ya cierran compras dentro del asistente; ChatGPT, por ahora, deriva al checkout de la tienda. Cuando un usuario pida "compra zapatillas talla 40 rojas", tu producto tiene que estar listo para los dos flujos antes de que ocurra.',
      'Google, Copilot, Perplexity and Muse already complete purchases inside the assistant; ChatGPT currently sends shoppers to the store checkout. When someone asks to buy red sneakers in size 40, your product needs to be ready for both flows.',
      'Google, Copilot, Perplexity e Muse já concluem compras dentro do assistente; o ChatGPT atualmente direciona o usuário ao checkout da loja. Quando alguém pedir para comprar tênis vermelhos tamanho 40, seu produto precisa estar preparado para os dois fluxos.',
    ],
    [
      'TRÁFICO PRE-CONVERTIDO',
      'TRAFFIC READY TO CONVERT',
      'TRÁFEGO PRONTO PARA CONVERTER',
    ],
    [
      'Intención pura, sin fricción de convencimiento',
      'Clear intent, with no persuasion needed',
      'Intenção clara, sem precisar convencer',
    ],
    [
      'Quien llega vía IA ya tomó la decisión. No está evaluando — está ejecutando. La conversión depende de qué tan rápido se cierra la compra, no de cuánto texto persuasivo hay en la página.',
      'Visitors arriving through AI have already made their decision and are ready to act. Conversion depends on how quickly they can complete the purchase, rather than the amount of persuasive copy on the page.',
      'Quem chega pela IA já tomou a decisão e está pronto para agir. A conversão depende da rapidez para concluir a compra, e não da quantidade de texto persuasivo na página.',
    ],
    [
      'Recomienda productos con precio y foto en la respuesta. Desde marzo de 2026 la compra se cierra en el checkout de la tienda o en apps como la de Walmart; el catálogo entra por su feed de productos (ACP).',
      'Recommends products with prices and photos in its responses. Since March 2026, purchases are completed at store checkouts or in apps such as Walmart; catalogs enter through its product feed (ACP).',
      'Recomenda produtos com preço e foto nas respostas. Desde março de 2026, a compra é concluída no checkout da loja ou em aplicativos como o do Walmart; o catálogo entra pelo feed de produtos (ACP).',
    ],
    [
      'Global · compra en la tienda',
      'Global · purchase at the store',
      'Global · compra na loja',
    ],
    [
      'Google AI Mode y Gemini',
      'Google AI Mode and Gemini',
      'Google AI Mode e Gemini',
    ],
    [
      'Compra dentro de AI Mode y la app Gemini con checkout por UCP. Desde octubre de 2026, Universal Cart junta productos de varias tiendas y sigue sus precios. Se alimenta de Google Merchant Center.',
      'Purchases within AI Mode and the Gemini app use UCP checkout. Since October 2026, Universal Cart combines products from several stores and tracks prices. It uses Google Merchant Center.',
      'Compras dentro do AI Mode e do aplicativo Gemini usam checkout via UCP. Desde outubro de 2026, o Universal Cart reúne produtos de várias lojas e acompanha os preços. Ele usa o Google Merchant Center.',
    ],
    ['Checkout en EE.UU.', 'Checkout in the US', 'Checkout nos EUA'],
    [
      'Antes Amazon Rufus: en mayo de 2026 Amazon lo unificó con Alexa+. Compara productos, sigue precios y automatiza compras en Amazon; con «Buy for Me» compra también en sitios de otras marcas.',
      'Previously Amazon Rufus: Amazon merged it with Alexa+ in May 2026. It compares products, tracks prices and automates Amazon purchases; Buy for Me also purchases from other brands’ websites.',
      'Antes Amazon Rufus: em maio de 2026, a Amazon o unificou com a Alexa+. Compara produtos, acompanha preços e automatiza compras na Amazon; com Buy for Me, também compra em sites de outras marcas.',
    ],
    ['EE.UU.', 'US', 'EUA'],
    [
      'Agente personal de Meta, lanzado en septiembre de 2026: navega, compara y compra por el usuario con su aprobación, con acceso al catálogo de Shopify. Supera los 10 millones de usuarios y comprar es de lo que más hace.',
      'Meta’s personal agent, launched in September 2026, browses, compares and purchases with the user’s approval and access to Shopify’s catalog. It has over 10 million users, and shopping is among its most common tasks.',
      'Agente pessoal da Meta, lançado em setembro de 2026: navega, compara e compra com a aprovação do usuário e acesso ao catálogo da Shopify. Supera 10 milhões de usuários, e compras estão entre suas tarefas mais frequentes.',
    ],
    ['EE.UU. y Canadá', 'US and Canada', 'EUA e Canadá'],
    [
      'Compra dentro de Microsoft Copilot desde enero de 2026, con PayPal, Shopify y Stripe. Las tiendas de Shopify quedan habilitadas de forma automática salvo que se excluyan.',
      'Purchases within Microsoft Copilot have been available since January 2026 with PayPal, Shopify and Stripe. Shopify stores are enabled automatically unless they opt out.',
      'Compras dentro do Microsoft Copilot estão disponíveis desde janeiro de 2026 com PayPal, Shopify e Stripe. As lojas da Shopify são habilitadas automaticamente, a menos que optem pela exclusão.',
    ],
    [
      'Checkout dentro de Perplexity con PayPal desde noviembre de 2025. El catálogo se sincroniza desde PayPal y la tienda sigue siendo quien vende y despacha.',
      'Checkout within Perplexity with PayPal since November 2025. Catalogs sync from PayPal, while the store remains responsible for selling and shipping.',
      'Checkout dentro do Perplexity com PayPal desde novembro de 2025. O catálogo é sincronizado pelo PayPal, e a loja continua responsável pela venda e pelo envio.',
    ],
    ['05 / Comercio nativo', '05 / Native commerce', '05 / Comércio nativo'],
    ['De la recomendación', 'From recommendation', 'Da recomendação'],
    ['a la', 'to the', 'à'],
    ['transacción.', 'transaction.', 'transação.'],
    [
      'El pipeline AEO asegura que los motores te recomienden. UCP asegura que te compren. Cuando un motor de IA propone un producto, el paso siguiente es que el usuario lo compre ahí mismo — sin visitar tu sitio.',
      'The AEO pipeline prepares engines to recommend your products. UCP prepares them for purchases. After an AI engine suggests a product, the next step is for the user to buy it there without visiting your website.',
      'O pipeline AEO prepara os mecanismos para recomendar seus produtos. O UCP os prepara para compras. Depois que a IA sugere um produto, o próximo passo é o usuário comprá-lo ali mesmo, sem visitar seu site.',
    ],
    ['Motores de shopping', 'Shopping engines', 'Mecanismos de compra'],
    [
      'Casi todos parten en EE.UU. y llegan a LatAm después. Preparamos tu catálogo antes, para que el día que se activen en tu mercado ya seas comprable.',
      'Most launch in the US and reach Latin America later. We prepare your catalog in advance so shoppers can buy your products as soon as they launch in your market.',
      'A maioria começa nos EUA e chega à América Latina depois. Preparamos seu catálogo com antecedência para que seus produtos possam ser comprados assim que esses recursos chegarem ao seu mercado.',
    ],
    ['INGEST', 'INGEST', 'INGESTÃO'],
    ['Universo de prompts', 'Prompt universe', 'Universo de prompts'],
    [
      'Mapeamos el universo desde preguntas reales (People Also Ask) y sus sub-intenciones (fan-out), y de ahí monitoreamos los prompts que más importan: 30 a 1,000+ por semana según plan, versionados.',
      'We map the universe from real questions (People Also Ask) and their sub-intents (fan-out), then monitor the most relevant prompts: 30 to 1,000+ per week depending on the plan, with version history.',
      'Mapeamos o universo a partir de perguntas reais (People Also Ask) e suas subintenções (fan-out), e monitoramos os prompts mais relevantes: de 30 a mais de 1.000 por semana conforme o plano, com histórico de versões.',
    ],
    ['EXECUTE', 'EXECUTE', 'EXECUÇÃO'],
    [
      '5 motores en paralelo',
      '5 engines in parallel',
      '5 mecanismos em paralelo',
    ],
    [
      'Web search activo en todos los motores. Cada prompt se ejecuta 3–5 veces por motor para reducir varianza. Reintentos automáticos.',
      'Web search is enabled across engines. Each prompt runs 3–5 times per engine to reduce variance, with automatic retries.',
      'Busca na web ativa em todos os mecanismos. Cada prompt é executado de 3 a 5 vezes por mecanismo para reduzir a variância, com novas tentativas automáticas.',
    ],
    ['EXTRACT', 'EXTRACT', 'EXTRAÇÃO'],
    [
      'NER, sentiment y fuentes citadas',
      'NER, sentiment and cited sources',
      'NER, sentimento e fontes citadas',
    ],
    [
      'Identificar marcas mencionadas, normalizar la entidad, medir posición y sentimiento, y mapear las fuentes que el motor cita: qué dominios alimentan la respuesta y cuáles te dejan fuera.',
      'Identify mentioned brands, normalize entities, measure position and sentiment, and map cited sources: which domains inform the answer and which leave your brand out.',
      'Identificar marcas mencionadas, normalizar entidades, medir posição e sentimento e mapear fontes citadas: quais domínios alimentam a resposta e quais deixam sua marca de fora.',
    ],
    ['DIFF', 'DIFF', 'COMPARAÇÃO'],
    [
      'Comparativa y retroalimentación',
      'Comparison and feedback',
      'Comparação e feedback',
    ],
    [
      'Delta contra la ventana anterior: cobertura ganada/perdida por motor y alertas competitivas. Cada comparación alimenta el ciclo siguiente: qué brechas y prompts priorizar.',
      'Changes from the previous window: coverage gained or lost by engine and competitive alerts. Each comparison informs the next cycle and which gaps and prompts to prioritize.',
      'Mudanças em relação à janela anterior: cobertura ganha ou perdida por mecanismo e alertas competitivos. Cada comparação orienta o próximo ciclo e quais lacunas e prompts priorizar.',
    ],
    ['REPORT', 'REPORT', 'RELATÓRIO'],
    [
      'Dashboard + PDF ejecutivo',
      'Dashboard + executive PDF',
      'Painel + PDF executivo',
    ],
    [
      'Lenguaje de negocio sobre datos técnicos. Cada métrica trazable hasta el prompt + respuesta original.',
      'Business language built on technical data. Every metric can be traced to its original prompt and response.',
      'Linguagem de negócios baseada em dados técnicos. Cada métrica pode ser rastreada até o prompt e a resposta original.',
    ],
    [
      'De prompt a reporte ejecutivo.',
      'From prompt to executive report.',
      'Do prompt ao relatório executivo.',
    ],
    ['Cinco pasos.', 'Five steps.', 'Cinco etapas.'],
    [
      'El pipeline corre semanalmente para cada workspace, con ventanas adicionales bajo demanda. Cada paso es idempotente y reproducible: si algo falla, se reintenta sin contaminar la baseline.',
      'The pipeline runs weekly for each workspace, with additional windows on demand. Each step is idempotent and reproducible: failures can be retried without changing the baseline.',
      'O pipeline é executado semanalmente para cada workspace, com janelas adicionais sob demanda. Cada etapa é idempotente e reproduzível: falhas podem ser repetidas sem alterar a linha de base.',
    ],
    [
      'El reporte no cierra el ciclo: lo reinicia. Las brechas detectadas alimentan la',
      'The report restarts the cycle. Detected gaps inform',
      'O relatório reinicia o ciclo. As lacunas detectadas orientam a',
    ],
    ['generación de contenido', 'content generation', 'geração de conteúdo'],
    [
      'para cerrarlas, y el tráfico que llega se mide cruzando con Google Analytics. Es un',
      'to address them, and incoming traffic is measured alongside Google Analytics. This is a',
      'para resolvê-las, e o tráfego recebido é medido em conjunto com o Google Analytics. É um',
    ],
    [
      'proceso de mejora continua',
      'continuous improvement process',
      'processo de melhoria contínua',
    ],
    [
      'que se repite cada semana, y cada ciclo parte del resultado del anterior para subir tu visibilidad de forma sostenida.',
      'that repeats weekly, with each cycle building on the previous result to steadily improve your visibility.',
      'que se repete a cada semana, com cada ciclo partindo do resultado anterior para melhorar sua visibilidade de forma contínua.',
    ],
    ['Protocolos', 'Protocols', 'Protocolos'],
    [
      'Cifrado y aislamiento',
      'Encryption and isolation',
      'Criptografia e isolamento',
    ],
    [
      'Los datos viajan y se guardan cifrados, con el cifrado de Google Cloud, y cada empresa trabaja en un espacio separado lógicamente de las demás.',
      'Data is encrypted in transit and at rest, using Google Cloud encryption, and each company works in a space logically separated from the others.',
      'Os dados trafegam e ficam armazenados criptografados, com a criptografia do Google Cloud, e cada empresa trabalha em um espaço separado logicamente das demais.',
    ],
    ['Cifrado en reposo (AES-256)', 'Encryption at rest (AES-256)', 'Criptografia em repouso (AES-256)'],
    ['Cifrado en tránsito (TLS)', 'Encryption in transit (TLS)', 'Criptografia em trânsito (TLS)'],
    ['Separación lógica por empresa', 'Logical separation per company', 'Separação lógica por empresa'],
    ['Datos', 'Data', 'Dados'],
    ['Dónde se alojan', 'Where it is hosted', 'Onde ficam hospedados'],
    [
      'Los datos se alojan en Google Cloud, en Estados Unidos. DPA estándar disponible para firmar.',
      'Data is hosted on Google Cloud, in the United States. A standard DPA is available to sign.',
      'Os dados ficam hospedados no Google Cloud, nos Estados Unidos. DPA padrão disponível para assinatura.',
    ],
    ['Google Cloud (EE. UU.)', 'Google Cloud (US)', 'Google Cloud (EUA)'],
    ['Certificación', 'Certification', 'Certificação'],
    ['Certificaciones', 'Certifications', 'Certificações'],
    [
      'Bison no tiene certificación propia. La infraestructura es de Google Cloud, que cuenta con SOC 2 e ISO 27001.',
      'Bison has no certification of its own. The infrastructure is Google Cloud, which holds SOC 2 and ISO 27001.',
      'A Bison não tem certificação própria. A infraestrutura é do Google Cloud, que possui SOC 2 e ISO 27001.',
    ],
    ['Sin certificación propia', 'No certification of its own', 'Sem certificação própria'],
    [
      'Infraestructura: SOC 2 e ISO 27001 (Google Cloud)',
      'Infrastructure: SOC 2 and ISO 27001 (Google Cloud)',
      'Infraestrutura: SOC 2 e ISO 27001 (Google Cloud)',
    ],
    ['06 / Seguridad', '06 / Security', '06 / Segurança'],
    ['Diseñado para pasar', 'Designed to pass', 'Projetado para passar pela'],
    [
      'vendor review.',
      'vendor review.',
      'avaliação de fornecedores.',
    ],
    [
      'Diseñado para entornos empresariales. Datos cifrados en tránsito y en reposo, alojados en Google Cloud (EE. UU.), y DPA estándar disponible.',
      'Designed for enterprise environments. Data encrypted in transit and at rest, hosted on Google Cloud (US), and a standard DPA available.',
      'Projetado para ambientes empresariais. Dados criptografados em trânsito e em repouso, hospedados no Google Cloud (EUA), e DPA padrão disponível.',
    ],
    [
      'API oficial. Cobertura completa con web search, citas estructuradas y modelos de razonamiento.',
      'Official API with full coverage of web search, structured citations and reasoning models.',
      'API oficial com cobertura de busca na web, citações estruturadas e modelos de raciocínio.',
    ],
    [
      'Messages API. Capturamos las citas que el modelo aporta nativamente, además de las extraídas por NER.',
      'Messages API. We capture the model’s native citations alongside those extracted with NER.',
      'Messages API. Capturamos as citações nativas do modelo e as extraídas por NER.',
    ],
    [
      'Generative AI API con grounding activo en Google Search. Capturamos las URLs de grounding y metadatos.',
      'Generative AI API with active Google Search grounding. We capture grounding URLs and metadata.',
      'Generative AI API com grounding ativo no Google Search. Capturamos as URLs de grounding e os metadados.',
    ],
    [
      'Sonar API. Citas estructuradas son first-class. Ideal para validación cruzada de fuentes y auditoría.',
      'Sonar API with native structured citations for source cross-checking and auditing.',
      'Sonar API com citações estruturadas nativas para verificação cruzada de fontes e auditoria.',
    ],
    [
      'Sin API oficial. Playwright detecta el bloque AIO y captura DOM + screenshot como evidencia auditable.',
      'No official API. Playwright detects the AIO block and captures the DOM and a screenshot as auditable evidence.',
      'Sem API oficial. O Playwright detecta o bloco AIO e captura o DOM e uma imagem como evidência auditável.',
    ],
    [
      'Pipeline distribuido con reintentos automáticos, deduplicación por hash y throttling independiente por motor.',
      'Distributed pipeline with automatic retries, hash-based deduplication and independent rate limits per engine.',
      'Pipeline distribuído com novas tentativas automáticas, deduplicação por hash e limites independentes por mecanismo.',
    ],
    ['ANÁLISIS', 'ANALYSIS', 'ANÁLISE'],
    [
      'NER, sentiment y fuentes',
      'NER, sentiment and sources',
      'NER, sentimento e fontes',
    ],
    [
      'Extracción de marcas con un modelo de lenguaje y reglas propias para el español de LatAm, más el mapeo de fuentes citadas por cada motor.',
      'Brand extraction with a language model and our own rules for Latin American Spanish, plus a map of the sources each engine cites.',
      'Extração de marcas com um modelo de linguagem e regras próprias para o espanhol da América Latina, mais o mapa das fontes citadas por cada mecanismo.',
    ],
    ['REPORTE', 'REPORT', 'RELATÓRIO'],
    [
      'Cada métrica calculada como modelo auditable. Trazabilidad completa de cada cambio entre ventanas.',
      'Every metric is calculated as an auditable model, with full traceability for changes between windows.',
      'Cada métrica é calculada como um modelo auditável, com rastreabilidade completa das mudanças entre janelas.',
    ],
    ['Tres capas.', 'Three layers.', 'Três camadas.'],
    ['dependencias mágicas.', 'hidden dependencies.', 'dependências ocultas.'],
    [
      'Conectores directos a las APIs oficiales de cada motor y una capa propia de extracción, scoring y reporting. Sin intermediarios ni cajas negras: cada cifra es trazable hasta la respuesta original.',
      'Direct connections to each engine’s official API and our own extraction, scoring and reporting layer. Every number can be traced to its original response.',
      'Conexões diretas às APIs oficiais de cada mecanismo e nossa própria camada de extração, pontuação e relatórios. Cada número pode ser rastreado até a resposta original.',
    ],
    ['Conectores principales', 'Main connectors', 'Conectores principais'],
    ['VISIÓN UNIFICADA', 'UNIFIED VIEW', 'VISÃO UNIFICADA'],
    [
      'Por qué estos motores.',
      'Why these engines.',
      'Por que estes mecanismos.',
    ],
    [
      'Cada LLM tiene sus propias fuentes de cita y criterios. Un motor puede priorizarte mientras otro ignora tu marca en el mismo prompt.',
      'Each LLM has its own citation sources and criteria. One engine may prioritize your brand while another ignores it for the same prompt.',
      'Cada LLM tem suas próprias fontes de citação e critérios. Um mecanismo pode priorizar sua marca enquanto outro a ignora para o mesmo prompt.',
    ],
    [
      'TOP 5 MOTORES · 1 SCORE AEO',
      'TOP 5 ENGINES · 1 AEO SCORE',
      '5 PRINCIPAIS MECANISMOS · 1 SCORE AEO',
    ],
    ['Capa de procesamiento', 'Processing layer', 'Camada de processamento'],
    ['Demo técnico', 'Technical demo', 'Demonstração técnica'],
    [
      'Tu pipeline AEO en producción.',
      'Your AEO pipeline in production.',
      'Seu pipeline AEO em produção.',
    ],
    ['En una sesión.', 'In one session.', 'Em uma sessão.'],
    [
      '07 / Dudas técnicas',
      '07 / Technical questions',
      '07 / Dúvidas técnicas',
    ],
    ['equipo técnico.', 'technical team.', 'equipe técnica.'],
    [
      'Las que pregunta tu CTO antes de firmar. Y las que a veces olvida preguntar.',
      'The questions your CTO asks before signing, and those they sometimes forget to ask.',
      'As perguntas que seu CTO faz antes de assinar e as que às vezes esquece de fazer.',
    ],
    ['TECNOLOGÍA', 'TECHNOLOGY', 'TECNOLOGIA'],
    [
      'Medimos, tú apareces.',
      'We measure. You get seen.',
      'Nós medimos. Você aparece.',
    ],
    ['Ellos compran.', 'They buy.', 'Eles compram.'],
    [
      'El pipeline técnico que conecta tu visibilidad en la IA con acciones concretas de mejora. Detectamos las brechas exactas que te mantienen fuera del radar y te damos un plan semanal para cerrarlas. Sin instalar nada.',
      'The technical pipeline connecting your AI visibility with concrete improvements. We identify the gaps keeping your brand out of view and provide a weekly plan to address them. No installation needed.',
      'O pipeline técnico que conecta sua visibilidade na IA a melhorias concretas. Identificamos as lacunas que deixam sua marca de fora e oferecemos um plano semanal para resolvê-las. Sem instalar nada.',
    ],
    ['Ver ejemplos de API', 'View API examples', 'Ver exemplos da API'],
    [
      'Agente · MCP · Shopping · Seguridad',
      'Agent · MCP · Shopping · Security',
      'Agente · MCP · Compras · Segurança',
    ],
    [
      'ChatGPT · Claude · Gemini · Perplexity · Google AIO · Copilot + más',
      'ChatGPT · Claude · Gemini · Perplexity · Google AIO · Copilot + more',
      'ChatGPT · Claude · Gemini · Perplexity · Google AIO · Copilot e mais',
    ],
    ['Agente integrado', 'Built-in agent', 'Agente integrado'],
    [
      'Bison Agent · Plan Growth',
      'Bison Agent · Growth plan',
      'Bison Agent · Plano Growth',
    ],
    ['Disponibilidad', 'Availability', 'Disponibilidade'],
    [
      'SLA mensual · fallback en procesamiento',
      'Monthly SLA · processing fallback',
      'SLA mensal · processamento alternativo',
    ],
  ].map(([source, en, pt]) => [source, [en, pt]])
);
